import { Component } from '@angular/core';
import { NzResultModule } from 'ng-zorro-antd/result';

@Component({
  selector: 'app-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.less'],
  standalone: true,
  imports: [NzResultModule],
})
export class ErrorPageComponent {}
